export enum PriceDuration {
  ONETIME = "One-time",
  WEEKLY = "Weekly",
  MONTHLY = "Monthly",
  ANNUAL = "Annual",
}
